import { useQueryClient } from '@tanstack/react-query'
import {
  getCostKey,
  getCostTransactionByIdKey,
  getCostTransactionCategoryKey,
  getCostTransactionGroupKey,
  getCostTransactionPieChartKey,
  getCostTransactionsHistoryInfiniteKey,
  getCostTransactionStackChartKey,
} from 'common/constants/queryKeys'

export const useInvalidateCostQueries = () => {
  const queryClient = useQueryClient()

  return () => {
    queryClient.invalidateQueries({ queryKey: getCostTransactionCategoryKey.all() })
    queryClient.invalidateQueries({ queryKey: getCostTransactionByIdKey.all() })
    queryClient.invalidateQueries({ queryKey: getCostTransactionsHistoryInfiniteKey.all() })
    queryClient.invalidateQueries({ queryKey: getCostTransactionPieChartKey.all() })
    queryClient.invalidateQueries({ queryKey: getCostTransactionStackChartKey.all() })
    queryClient.invalidateQueries({ queryKey: getCostTransactionGroupKey.all() })
    queryClient.invalidateQueries({ queryKey: getCostKey.all() })
  }
}
